import { NARRATIVE_FRAGMENT } from './narrativeFragment';
import { COMPANY_FRAGMENT } from '../companyFragment';
import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query NarrativeById($narrativeId: String!) {
    NarrativeById(narrativeId: $narrativeId) {
      ...NarrativeFields
      company {
        ...CompanyFields
      }
    }
  }
`,
  [NARRATIVE_FRAGMENT, COMPANY_FRAGMENT]
);

export const useNarrativeById = makeGqlQuery(QUERY);
